export function getFieldNames(inputObj) {
    return Object.keys(inputObj).map(key => {
        // Convert key to title case and replace underscores with spaces
        return key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    });
}

export function modifyCamelFieldNames(inputObject) {
    const modifiedObject = {};
    for (const key in inputObject) {
        if (Object.prototype.hasOwnProperty.call(inputObject, key)) {
            // Modify field name as per requirement
            let modifiedKey = key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
            modifiedObject[key] = modifiedKey;
        }
    }
    return modifiedObject;
}

export const returnCamelText = (text) => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()

export const isRegisterDetailsErrEmpty = (errors) => {
    return Object.values(errors).every((value) => value === "");
};

export function decreaseContent(sentence) {
    const words = sentence.split(" ");
    const reducedWords = words.slice(0, 4);
    const moreToShow = Boolean(words.slice(4).join(" "));
    const reducedSentence = reducedWords.join(" ");
    return { reducedSentence, moreToShow };
}

export function transformString(str) {
    str = str.toLowerCase();
    if (str.endsWith('s')) {
        str = str.slice(0, -1);
    }
    const capitalizedStr = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalizedStr;
}

export function removewithfilter(arr) {
    let outputArray = arr.filter(function (v, i, self) {
        return i == self.indexOf(v);
    });
    return outputArray;
}


export function removeLastAndModifyPath(url, destVals, vals) {
    // Split the URL into parts
    const parts = url.split('/');

    // Remove the last element (which should be 'setting')
    parts.splice(-1 * (vals ? vals : 1), 1 * (vals ? vals : 1));

    // Add 'company/add' to the end
    parts.push(...destVals);

    // Join the parts back together into a string
    const newUrl = parts.join('/');

    return newUrl;
}

export function isValidLink(link) {
    // Regex pattern to match basic URL format
    const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;

    // Test if the link matches the pattern
    return urlPattern.test(link);
}

export function displayText(approved, rejected, uploadId) {
    if (uploadId) {
        if (!rejected && !approved) {
            return { post: "Waiting posts", menu: 0 };
        } else if (approved) {
            return { post: "Approved posts", menu: 1 };
        } else if (rejected && !approved) {
            return { post: "Rejected posts", menu: 2 };
        }
    }
    else {
        return { post: "Query List", menu: 4 };
    }

}

export const convertSeconds = (seconds) => {
    const days = Math.floor(seconds / (24 * 3600));
    seconds %= (24 * 3600);
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return `${days > 0 ? days + " days, " : ""} ${hours > 0 ? hours + " hours, " : ""} ${minutes > 0 ? minutes + " minutes, " : ""} ${secs.toFixed(2)} seconds`;
};

export function generateRandomNumber() {
    const randomNumber = Math.floor(Math.random() * 1000) + 1;
    return String(randomNumber).padStart(3, '0');
}

export function filterUndefinedFields(obj) {
    const filteredEntries = Object.entries(obj).filter(
        ([key, value]) => (value !== undefined && value != "")
    );
    const filteredObject = Object.fromEntries(filteredEntries);

    return filteredObject;
}

export function isObjectEmpty(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false; // Or throw an error, depending on desired behavior
    }
    return Object.keys(obj).length === 0;
}

const formatLabel = (key, type) => {
    if (!isNaN(key)) {
        return ` ${parseInt(key, 10) + 1}`;
    }
    if (key === "createdAt") return "Creation Time";
    if (type === "agent" && key === "name") return "Agent Company Name";
    if (key.includes("_")) {
        return key
            .split("_")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }
    return key
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/^./, str => str.toUpperCase());
};

export function formatMissingFieldLabel(missingFieldKey) {
    if (!missingFieldKey || typeof missingFieldKey !== 'string') {
        return "";
    }
    const parts = missingFieldKey.split('.');
    const formattedParts = parts.map(part => formatLabel(part));
    const lastPart = formattedParts.pop();
    return `${formattedParts.join(" - ")} - [${lastPart}]`;
}